import React from 'react'
import Navbar from './Navbar'
import Features from './Features'
import HowItWorks from './HowItWorks'
import Testimonials from './Testimonials'
import Pricing from './Pricing'
import Faq from './Faq'
import Footer from './Footer'
import "./HomeMain.css"
import ContactSection from './ContactSection'
import Hero1 from './Hero1'
import PracticeAreas from './PracticeAreas'
import AboutUs from './AboutUs.jsx'

function HomeMain() {
  return (
    <div>
 {/* <Navbar/> */}
 <Hero1/>
  <PracticeAreas/>
  <AboutUs/>
 <Features/>
 <HowItWorks/>
 <Testimonials/>
 <Pricing/>
 <Faq/>
 <ContactSection/>
 <Footer/>
    </div>
  )
}

export default HomeMain